import Styles from "./FormLabel.module.scss";

type Props = {
	children: string;
};

export function FormLabel({ children }: Props) {
	return <div className={Styles.FormLabel}>{children}</div>;
}
